import React from 'react';
import SelectList from "./SelectList";

const yearList = Array.from({ length: 10 }, (_, i) => {
    const year = new Date().getFullYear() + i;
    return { label: `${year}`, value: year };
});

const monthList = Array.from({ length: 12 }, (_, i) => {
    const month = i + 1;
    return { label: `${month}`, value: month };
});

const dayList = Array.from({ length: 31 }, (_, i) => {
    const day = i + 1;
    return { label: `${day}`, value: day };
});

class RecommendDateInput extends React.Component {
    constructor(props) {
        super(props);

        this.validateDates = this.validateDates.bind(this);

        this.handleRecommendDateHandler = this.handleRecommendDateHandler.bind(this);
        this.getDays = this.getDays.bind(this);
        this.getDayOfWeek = this.getDayOfWeek.bind(this);

        this.state = {
            startYear: '',
            startMonth: '',
            startDay: '',

            endYear: '',
            endMonth: '',
            endDay: '',

            validDate: '',
        }
    }
    componentDidMount() {
        const { id, setVariable } = this.props;
        setVariable(id, '년 월 일 ~ 년 월 일');
    }

    getDays = (year, month) => {
        if (!year || !month) return dayList;
        const daysInMonth = new Date(year, month, 0).getDate();
        return dayList.slice(0, daysInMonth);
    }// end getDays

    getDayOfWeek(year, month, day) {
        if (!year || !month || !day) return '';
        const date = new Date(year, month - 1, day);
        const days = ['일', '월', '화', '수', '목', '금', '토'];
        return days[date.getDay()];
    }// end getDayOfWeek

    validateDates() {
        const { startYear, startMonth, startDay, endYear, endMonth, endDay } = this.state;
        const startDate = new Date(startYear, startMonth, startDay);
        const endDate = new Date(endYear, endMonth, endDay);

        if (startDate > endDate) this.setState({ validDate: "시작일은 종료일보다 빠르게 설정해주세요! 메시지 검수에서 반려될 수 있습니다" });
        else this.setState({ validDate: "" });
    }// end validateDates

    handleRecommendDateHandler(type, value) {
        const { id, setVariable } = this.props;
        const { startYear, startMonth, startDay, endYear, endMonth, endDay } = this.state;
        let startWhen = this.getDayOfWeek(startYear, startMonth, startDay);
        let endWhen = this.getDayOfWeek(endYear, endMonth, endDay);
        switch (type) {
            case "startYear":
                startWhen = this.getDayOfWeek(value, startMonth, startDay);
                this.setState({startYear: value}, this.validateDates);
                if (startYear === endYear) setVariable(id, `${value}년 ${startMonth}월 ${startDay}일(${startWhen})~${endMonth}월 ${endDay}일(${endWhen})`)
                else setVariable(id, `${value}년 ${startMonth}월 ${startDay}일(${startWhen})~${endYear}년 ${endMonth}월 ${endDay}일(${endWhen})`)
                break;
            case "startMonth":
                startWhen = this.getDayOfWeek(startYear, value, startDay);
                this.setState({startMonth: value}, this.validateDates);
                if (startYear === endYear) setVariable(id, `${startYear}년 ${value}월 ${startDay}일(${startWhen})~${endMonth}월 ${endDay}일(${endWhen})`)
                else setVariable(id, `${startYear}년 ${value}월 ${startDay}일(${startWhen})~${endYear}년 ${endMonth}월 ${endDay}일(${endWhen})`)
                break;
            case "startDay":
                startWhen = this.getDayOfWeek(startYear, startMonth, value);
                this.setState({startDay: value},this.validateDates);
                if (startYear === endYear) setVariable(id, `${startYear}년 ${startMonth}월 ${value}일(${startWhen})~${endMonth}월 ${endDay}일(${endWhen})`)
                else setVariable(id, `${startYear}년 ${startMonth}월 ${value}일(${startWhen})~${endYear}년 ${endMonth}월 ${endDay}일(${endWhen})`)
                break;
            case "endYear":
                endWhen = this.getDayOfWeek(value, endMonth, endDay);
                this.setState({endYear: value}, this.validateDates);
                if (startYear === value) setVariable(id, `${startYear}년 ${startMonth}월 ${startDay}일(${startWhen})~${endMonth}월 ${endDay}일(${endWhen})`)
                else setVariable(id, `${startYear}년 ${startMonth}월 ${startDay}일(${startWhen})~${value}년 ${endMonth}월 ${endDay}일(${endWhen})`)
                break;
            case "endMonth":
                endWhen = this.getDayOfWeek(endYear, value, endDay);
                this.setState({endMonth: value}, this.validateDates);
                if (startYear === endYear) setVariable(id, `${startYear}년 ${startMonth}월 ${startDay}일(${startWhen})~${value}월 ${endDay}일(${endWhen})`)
                else setVariable(id, `${startYear}년 ${startMonth}월 ${startDay}일(${startWhen})~${endYear}년 ${value}월 ${endDay}일(${endWhen})`)
                break;
            case "endDay":
                endWhen = this.getDayOfWeek(endYear, endMonth, value);
                this.setState({endDay: value}, this.validateDates);
                if (startYear === endYear) setVariable(id, `${startYear}년 ${startMonth}월 ${startDay}일(${startWhen})~${endMonth}월 ${value}일(${endWhen})`)
                else setVariable(id, `${startYear}년 ${startMonth}월 ${startDay}일(${startWhen})~${endYear}년 ${endMonth}월 ${value}일(${endWhen})`)
                break;
            default:
                break;
        }// end switch
    }// end handler

    render() {
        const { startYear, startMonth, startDay, endYear, endMonth, endDay, validDate } = this.state;

        const startDays = this.getDays(startYear, startMonth);
        const endDays = this.getDays(endYear, endMonth);

        const { handleRecommendDateHandler } = this;

        return (
            <div className={""}>
                <SelectList
                    className="form-select d-inline w-auto"
                    id={"startYear"}
                    value={startYear}
                    list={yearList}
                    onChange={handleRecommendDateHandler}
                    disableDefault={false}
                />
                <span className={"mx-1"}>년</span>
                <SelectList
                    className="form-select d-inline w-auto"
                    id={"startMonth"}
                    value={startMonth}
                    list={monthList}
                    onChange={handleRecommendDateHandler}
                    disableDefault={false}
                />
                <span className={"mx-1"}>월</span>
                <SelectList
                    className="form-select d-inline w-auto"
                    id={"startDay"}
                    value={startDay}
                    list={startDays}
                    onChange={handleRecommendDateHandler}
                    disableDefault={false}
                />
                <span className={"mx-1"}>일 ~ </span>
                <SelectList
                    className="form-select d-inline w-auto"
                    id={"endYear"}
                    value={endYear}
                    list={yearList}
                    onChange={handleRecommendDateHandler}
                    disableDefault={false}
                />
                <span className={"mx-1"}>년</span>
                <SelectList
                    className="form-select d-inline w-auto"
                    id={"endMonth"}
                    value={endMonth}
                    list={monthList}
                    onChange={handleRecommendDateHandler}
                    disableDefault={false}
                />
                <span className={"mx-1"}>월</span>
                <SelectList
                    className="form-select d-inline w-auto"
                    id={"endDay"}
                    value={endDay}
                    list={endDays}
                    onChange={handleRecommendDateHandler}
                    disableDefault={false}
                />
                <span className={"mx-1"}>일</span>

                {validDate && <div style={{fontSize: 11}} className="text-danger mt-2"> * {validDate}</div>}
            </div>
        )
    }
}

export default RecommendDateInput;
